import API from '../../../services/API';
import { setError, startSpinner, stopSpinner } from '../../../actions/common/actionCreators';
import { ICustomGroupingResponse } from '../../../modules/custom-grouping/types/customGroupingTypes';
import { CUSTOM_GROUPING_ACTION_TYPES } from '../../../constants/actionTypes/customGroupingActionTypes';

export const setCustomGroupingData = data => ({
    type: CUSTOM_GROUPING_ACTION_TYPES.SET_CUSTOM_GROUPING,
    payload: data,
});

const actions = { setError, startSpinner, stopSpinner };

export const fetchCustomGroupingDetails = (url, args) => async dispatch => {
    const data: ICustomGroupingResponse = await API.getData(url, dispatch, actions, true);
    const { processData } = args;
    if (data) {
        const customGroupingResponse = processData({
            customGroupingData: data,
            ...args
        });
        dispatch(setCustomGroupingData({ ...data, ...customGroupingResponse }));
    } else {
        console.error('Cannot get custom grouping', url);
    }
};
